/**
 * LogoMark — شعار KamelCloud المعتمد: شارة مربّعة بزوايا دائرية بخلفية
 * تركوازية، حرف K أبيض بارز، وقوسا كود ذهبيان على الجانبين. اعتُمد هذا
 * التصميم بعد عرض 3 تصورات مختلفة والتعديل عليه بناءً على الطلب.
 */
export default function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      className={className}
      role="img"
      aria-label="KamelCloud"
    >
      <rect x="0" y="0" width="128" height="128" rx="24" fill="#0F5257" />
      <path
        d="M 34 42 L 22 64 L 34 86"
        fill="none"
        stroke="#C9A227"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 104 42 L 116 64 L 104 86"
        fill="none"
        stroke="#C9A227"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="53" y="24" width="15" height="80" rx="3" fill="#FFFFFF" />
      <polygon points="70,61 70,67 98,24 78,24" fill="#FFFFFF" />
      <polygon points="70,61 70,67 98,104 78,104" fill="#FFFFFF" />
    </svg>
  );
}
